









































































































































import { Component, Vue } from 'vue-property-decorator';
import { Account } from '../models/account';
import { Country } from '../models/country';

@Component
export default class Search extends Vue {
  public pagination: any = {
    rowsPerPage: -1,
  };
  public query: string = '';
  public searchIcon: string = 'mdi-magnify';
  public isLoading: boolean = false;
  public didYouSearchSomething = false;

  public doSearchAccount() {
    this.isLoading = true;
    this.didYouSearchSomething = this.query.length > 0;

    const payload = {
      profile: this.query,
    };
    this.$store.dispatch('searchAccount', payload)
      .then((r) => {
        this.isLoading = false;
      });
  }

  public clearAccounts() {
    if (this.query === '') {
      this.doSearchAccount();
    }
  }

  get accounts() {
    return this.$store.getters.getAccounts;
  }

  get accountsCount() {
    return (this.accounts as Account[]).length;
  }

  get countries() {
    return this.$store.getters.getCountries;
  }

  get shouldDisplayAccounts() {
    return !this.isLoading && this.query.length > 0 && this.accountsCount > 0;
  }

  get shouldDisplayNoResults() {
    return !this.isLoading && this.didYouSearchSomething && this.accountsCount === 0;
  }

  get shouldDisplayInitialMessage() {
    return !this.isLoading && !this.didYouSearchSomething && this.query.length === 0;
  }

  private getCountryCode(countryName: string): string {
    return this.countries.find((c: Country) => c.name === countryName).alpha2Code || '';
  }
}
